import { fmtMoneyAtLeast } from './moneyFormat';

// What an attack-path stage tile says (dashboard card + /attack-paths detail). Only confirmed data:
// a stage with open findings shows its count and live exposure; a stage with none shows a label and
// no dollar figure ("Risk forming" when nothing has been found there, "remediated" when everything
// found there is fixed).
export const RISK_FORMING = 'Risk forming';

export function stageFigure(stage) {
  const open = stage.openRiskCount || 0;
  if (open > 0) {
    return {
      kind: 'open',
      status: `${open}/${stage.riskCount} open`,
      amount: stage.stageFinancialImpact > 0 ? fmtMoneyAtLeast(stage.stageFinancialImpact) : '—',
    };
  }
  return {
    kind: stage.isEmpty ? 'forming' : 'remediated',
    status: stage.isEmpty ? RISK_FORMING : `0/${stage.riskCount} open · remediated`,
    amount: null,
  };
}

// Each stage's share of a path's exposure, in percent, keyed by stage name. A risk can sit in more
// than one stage of a path (AttackPathAnalyzer.ResolveStages), so its dollars appear in each of
// those stages' amounts while the path total counts it once — dividing by the path total let the
// shares add up to more than 100%. The denominator is the sum of the stage amounts instead, so the
// shares always add up to 100% and read as "how this path's stage figures split".
export function stageShares(stages) {
  const amounts = (stages || []).map(s => Math.max(Number(s.stageFinancialImpact) || 0, 0));
  const total = amounts.reduce((sum, a) => sum + a, 0);
  const shares = {};
  (stages || []).forEach((s, i) => { shares[s.stageName] = total > 0 ? (amounts[i] / total) * 100 : 0; });
  return shares;
}
